<template>
  <div class="home-view">
    <nav class="navbar">
      <div class="nav-brand">个人助手</div>
      <div class="nav-links">
        <router-link to="/home/search" class="nav-link">单词查询</router-link>
        <router-link to="/home/book" class="nav-link">单词本</router-link>
        <router-link to="/home/notes" class="nav-link">笔记</router-link>
        <router-link to="/home/diary" class="nav-link">日记</router-link>
      </div>
      <div class="nav-right">
        <span class="nav-user">{{ userName }}</span>
        <button type="button" @click="logout" class="btn-logout">退出</button>
      </div>
    </nav>
    <div class="content-area">
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  data() {
    return {
      userName: localStorage.getItem('userName') || '用户'
    }
  },
  methods: {
    logout() {
      if (confirm('确定要退出登录吗？')) {
        localStorage.removeItem('token')
        localStorage.removeItem('refreshToken')
        localStorage.removeItem('userName')
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style scoped>
.home-view {
  min-height: 100vh;
  background: var(--surface);
}

.navbar {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 56px;
  padding: 0 24px;
  background: var(--surface-card);
  border-bottom: 1px solid var(--border);
  box-shadow: var(--shadow);
}

.nav-brand {
  font-family: var(--font-display);
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--ink);
  letter-spacing: -0.02em;
}

.nav-links {
  display: flex;
  align-items: center;
  gap: 8px;
}

.nav-link {
  padding: 8px 16px;
  border-radius: var(--radius);
  color: var(--ink-secondary);
  text-decoration: none;
  font-weight: 500;
  font-size: 0.95rem;
  transition: background 0.2s, color 0.2s;
}

.nav-link:hover {
  color: var(--ink);
  background: var(--surface);
}

.nav-link.router-link-active {
  color: var(--accent);
  background: var(--accent-soft);
}

.nav-right {
  display: flex;
  align-items: center;
  gap: 16px;
}

.nav-user {
  font-size: 0.9rem;
  color: var(--ink-secondary);
  font-weight: 500;
}

.btn-logout {
  padding: 8px 14px;
  border-radius: var(--radius);
  border: 1px solid var(--border);
  background: transparent;
  color: var(--ink-muted);
  font-size: 0.85rem;
  font-weight: 500;
  transition: all 0.2s;
}

.btn-logout:hover {
  border-color: var(--danger);
  color: var(--danger);
}

.content-area {
  padding: 24px 20px 48px;
  max-width: 1200px;
  margin: 0 auto;
}

@media (max-width: 768px) {
  .navbar {
    flex-wrap: wrap;
    height: auto;
    padding: 12px 16px;
    gap: 12px;
  }
  .nav-links {
    order: 3;
    width: 100%;
    justify-content: flex-start;
    overflow-x: auto;
  }
  .nav-link {
    padding: 6px 12px;
    font-size: 0.9rem;
    white-space: nowrap;
  }
  .content-area {
    padding: 16px 12px 40px;
  }
}
</style>
